import React from 'react';
export function TomoCards() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const tomos = [{
    color: 'text-green-400',
    title: 'Sistemas Forestales',
    emoji: '🌱'
  }, {
    color: 'text-emerald-400',
    title: 'Viveros Forestales',
    emoji: '🌿'
  }, {
    color: 'text-teal-400',
    title: 'Plantación y Manejo',
    emoji: '🌲'
  }, {
    color: 'text-lime-400',
    title: 'Especies Forestales',
    emoji: '🌳'
  }, {
    color: 'text-amber-400',
    title: 'Aprovechamiento',
    emoji: '🪵'
  }, {
    color: 'text-cyan-400',
    title: 'Sustentabilidad',
    emoji: '♻️'
  }];
  return <section className="bg-[#0B1F17] py-4 px-3 border-b border-[#1F3D2B]" data-id="element-220">
      <div className="max-w-4xl mx-auto" data-id="element-221">
        <div className="flex gap-2 overflow-x-auto pb-2 scrollbar-hide justify-start md:justify-center" data-id="element-222">
          {tomos.map((tomo, i) => <div key={i} onClick={scrollToPricing} className="bg-[#102A1F] border border-[#1F3D2B] rounded-lg p-2 text-center cursor-pointer transform hover:-translate-y-1 hover:border-[#D4A843] hover:glow-gold transition-all duration-300 shadow-sm flex-shrink-0 w-[80px] md:w-28 flex flex-col justify-center items-center" data-id="element-223">
              <div className="text-xl md:text-2xl mb-1" data-id="element-224">{tomo.emoji}</div>
              <h4 className={`font-black text-[9px] md:text-[11px] leading-tight ${tomo.color}`} data-id="element-225">
                {tomo.title}
              </h4>
            </div>)}
        </div>
      </div>
    </section>;
}